import { ImageScaleViewOpts } from '@play-co/timestep-core/lib/ui/ImageScaleView';
import { DaycareId } from 'src/replicant/daycare';
import * as Daycare from 'src/replicant/daycare';
import { ImageScaleView } from '@play-co/timestep-core/ui';
import { daycareIcons } from './style';
import { getCreativeSuffix } from 'src/lib/utils';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import StateObserver from 'src/StateObserver';
import uiConfig from 'src/lib/ui/config';

type DaycareOptionPanelOpts = Omit<
  ImageScaleViewOpts,
  'image' | 'width' | 'height'
> & {
  daycareId: DaycareId;
};

export class DaycareOptionPanel extends ImageScaleView {
  constructor({ daycareId, ...opts }: DaycareOptionPanelOpts) {
    super({
      ...opts,
      ...uiConfig.buruburu.care.confirmation.careItemPanel,
    });

    const daycareOption = Daycare.ruleset.daycareOptions[daycareId];

    // icon
    this.addSubview(
      new ImageScaleView({
        scaleMethod: 'contain',
        x: 20,
        y: 20,
        width: 156,
        height: 137,
        image: daycareIcons[daycareId],
      }),
    );

    // name
    const name = daycareOption[`name_${getCreativeSuffix()}`];
    this.addSubview(
      new LangBitmapFontTextView({
        font: 'Body',
        color: '#9A7171',
        y: 25,
        size: 30,
        x: 190,
        height: 39,
        width: 283,
        localeText: () => name.replace(/\n/g, ''), // Strip newlines
        verticalAlign: 'bottom',
      }),
    );

    // description
    this.addSubview(
      new LangBitmapFontTextView({
        size: 25,
        x: 190,
        y: 85,
        width: 283,
        height: 64,
        font: 'Body',
        color: '#9A7171',
        localeText: () => daycareOption[`desc_${getCreativeSuffix()}`],
        wordWrap: StateObserver.getState().ui.locale === 'en',
      }),
    );
  }
}
